export default __webpack_public_path__ + "static/media/close-chevron.5f97c02b.svg";